
import PulseBottom from '../pulse-bottom.vue'
import PulseButton from '../pulse-button.vue'
import PulseEmpty from '../pulse-empty.vue'
import TrackerSelect from './tracker-select.vue'
import TrackerFilters from './tracker-filters.vue'
import TopicItem from './topic-item.vue'
import TrackerItem from './tracker-item.vue'
import $tracker from 'stores/tracker'
import {markRaw} from 'vue'

export default {
  components: {TopicItem, PulseButton, TrackerFilters, TrackerItem, PulseEmpty, PulseBottom, TrackerSelect},
  props: {
    chosenId: {
      type: String,
      default: undefined
    }
  },
  emits: ['toggle-tab'],
  data() {
    return {
      tracker_width: 0,
      tracker_items: [],
      filters: {},
      clearing_filters: false,
      TRACKER_OPTS: markRaw([
        {
          title: 'Track a company',
          icon: 'building-02',
          onClick: () => this.$dispatch('track-companies')
        },
        {
          title: 'Track a person',
          icon: 'user-03',
          onClick: () => this.$dispatch('track-person')
        },
        {
          title: 'Track a topic',
          icon: 'hash-02-a',
          onClick: () => this.$dispatch('track-topic')
        },
      ]),
    }
  },
  computed: {
    type_counts() {
      return $tracker.tracker_types_count
    },
    items(){
      return $tracker.items
    },
    empty() {
      return this.items.length === 0
    },
    loading() {
      return $tracker.loading || this.clearing_filters
    },
    tracker_atend() {
      let count = 0
      this.filters.types?.forEach(cat => {
        count += this.type_counts[cat]
      })
      if (count === 0) count = this.type_counts?.all
      return this.items.length >= count
    },
    more_available() {
      return !this.empty && !this.tracker_atend
    },
    categories_count() {
      return $tracker.categories_count
    },
    has_filters() {
      return !!(this.filters?.search || this.filters?.types?.length)
    },
  },
  watch: {
    more_available: {
      handler: async function (val) {
        if (!val) return
        await this.$nextTick()
        this.initBottomObserver()
      },
      immediate: true
    },
    'items.length': function (next, prev){
      if (next >= prev) return
      this.$refs.scroller.scrollToTop(true)
    },
    filters(){
      if (this.clearing_filters) return
      this.$debounce_500(this.loadItems)
    }
  },
  async mounted() {
    this.loadItems()
  },
  methods: {
    async loadItems(params = {}){
      await $tracker.load({...params, ...this.filters})
    },
    async onWheel(ev) {
      if (this.loading) return
      if (!this.empty) return
      await this.loadItems()
    },
    async onLoadMore(){
      if (this.loading) return
      if (this.empty) return
      if (this.tracker_atend) return
      await this.loadItems({more:true})
    },
    initBottomObserver(){
      const observer = this.$refs.scroller.getObserver()
      observer.unobserveAll() 
      observer.observe(
        this.$refs.bottom.getLoader(),
        entry => entry.position === 'visible' && this.onLoadMore()
      )
    },
    async clearAll(){
      if (this.clearing_filters) return
      this.clearing_filters = true
      this.$abortDebounce(this.loadItems)
      this.$refs.filters.clearAll()
      await this.$nextTick()
      try {
        await this.loadItems()
      } finally {
        this.clearing_filters = false
      }
    },
    editCompany(company_id) {
      this.$dispatch('edit-company', {company_id})
      this.$refs[company_id]?.openContacts()
    },
    onResize(ev){
      this.tracker_width = ev[0]?.contentRect.width
    }
  }
}
